/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Telegram_OffInputs */

const en_fw_notify_telegram_off = /** @type {(inputs: Fw_Notify_Telegram_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telegram is not configured on this server — NEEDS ADMIN ACTION: set TELEGRAM_BOT_TOKEN.`)
};

const id_fw_notify_telegram_off = /** @type {(inputs: Fw_Notify_Telegram_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telegram belum dikonfigurasi di server — BUTUH TINDAKAN ADMIN: isi TELEGRAM_BOT_TOKEN.`)
};

/**
* | output |
* | --- |
* | "Telegram is not configured on this server — NEEDS ADMIN ACTION: set TELEGRAM_BOT_TOKEN." |
*
* @param {Fw_Notify_Telegram_OffInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_telegram_off = /** @type {((inputs?: Fw_Notify_Telegram_OffInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Telegram_OffInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_telegram_off(inputs)
	return en_fw_notify_telegram_off(inputs)
});